// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Research Topics Ranking view ─── */
.ResearchTopicsRankingView_section__\\+8t3K {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 22px 24px 26px;
  background: var(--bg-2, #fff);
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
}

.ResearchTopicsRankingView_head__aSHDa {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ResearchTopicsRankingView_title__UBuia {
  margin: 0;
  font-family: "Lora", "Georgia", serif;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}

.ResearchTopicsRankingView_subtitle__qqNu8 {
  margin: 0;
  font-size: 12.5px;
  color: var(--grey-text, #64748b);
  line-height: 1.5;
  max-width: 720px;
}

.ResearchTopicsRankingView_body__DU-L- {
  display: flex;
  align-items: stretch;
  gap: 20px;
  min-height: 480px;
}

/* ─── Vertical keyword tabs ─── */
.ResearchTopicsRankingView_keyword-tabs__-D31U {
  flex: 0 0 200px;
  min-width: 160px;
  border-right: 1px solid rgba(15, 52, 96, 0.1);
}
.ResearchTopicsRankingView_keyword-tabs__-D31U .MuiTabs-flexContainer {
  align-items: stretch;
}

.ResearchTopicsRankingView_keyword-tabs-indicator__\\+ILUi {
  background-color: #0f3460;
  width: 3px;
  left: 0;
  right: auto;
}

.ResearchTopicsRankingView_keyword-tab__OtGwU {
  align-items: flex-start !important;
  justify-content: flex-start !important;
  text-align: left !important;
  min-height: 44px;
  padding: 10px 16px 10px 14px !important;
  font-size: 13px;
  font-weight: 600;
  color: var(--grey-text, #64748b);
  border-radius: 8px 0 0 8px;
  transition: background 0.15s, color 0.15s;
}
.ResearchTopicsRankingView_keyword-tab__OtGwU .MuiTab-iconWrapper {
  align-items: flex-start;
}
.ResearchTopicsRankingView_keyword-tab__OtGwU:hover {
  background: rgba(15, 52, 96, 0.05);
}
.ResearchTopicsRankingView_keyword-tab--selected__v5sF\\+ {
  color: #0f3460 !important;
  background: rgba(15, 52, 96, 0.07);
}

/* ─── Active keyword content ─── */
.ResearchTopicsRankingView_keyword-content__97tmU {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.ResearchTopicsRankingView_keyword-panel__k\\+fx2 {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ─── Horizontal entity-type tabs ─── */
.ResearchTopicsRankingView_entity-tabs__B0vot {
  min-height: 36px;
  border-bottom: 1px solid rgba(15, 52, 96, 0.1);
}
.ResearchTopicsRankingView_entity-tabs__B0vot .MuiTabs-flexContainer {
  gap: 4px;
}

.ResearchTopicsRankingView_tabs-indicator__9idT\\+ {
  background-color: #0f3460;
  height: 2px;
}

.ResearchTopicsRankingView_entity-tab__56Fqr {
  min-height: 36px;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--grey-text, #64748b);
}
.ResearchTopicsRankingView_entity-tab--selected__VWWZD, .ResearchTopicsRankingView_entity-tab__56Fqr.Mui-selected {
  color: #0f3460 !important;
}

.ResearchTopicsRankingView_tab--selected__9NSwh {
  color: #0f3460 !important;
}

.ResearchTopicsRankingView_panel__iOM55 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ─── Scrollable ranking table ─── */
.ResearchTopicsRankingView_scroll-area__9F1WE {
  max-height: 520px;
  overflow-y: auto;
  overflow-x: auto;
  padding: 0 8px 4px 0;
  /* Slimmer scrollbar so it doesn't dominate the visual */
  scrollbar-width: thin;
  scrollbar-color: rgba(15, 52, 96, 0.25) transparent;
}
.ResearchTopicsRankingView_scroll-area__9F1WE::-webkit-scrollbar {
  width: 8px;
}
.ResearchTopicsRankingView_scroll-area__9F1WE::-webkit-scrollbar-thumb {
  background: rgba(15, 52, 96, 0.25);
  border-radius: 4px;
}
.ResearchTopicsRankingView_scroll-area__9F1WE::-webkit-scrollbar-track {
  background: transparent;
}

.ResearchTopicsRankingView_table-wrap__KzHdG {
  min-width: 0;
}

.ResearchTopicsRankingView_avatar__HH3vP {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  object-fit: contain;
}

.ResearchTopicsRankingView_avatar--institution__h48D5 {
  width: 128px;
  aspect-ratio: 16/9;
}

.ResearchTopicsRankingView_avatar--other__zC01p {
  width: 60px;
  aspect-ratio: 1/1;
}

.ResearchTopicsRankingView_avatar--fallback__j\\+YfJ {
  font-size: 11px;
  font-weight: 700;
  color: #0f3460;
  background: rgba(15, 52, 96, 0.1);
  letter-spacing: 0.3px;
}

.ResearchTopicsRankingView_table__Mtf\\+s {
  width: 100%;
  min-width: 360px;
  border-collapse: collapse;
  table-layout: fixed;
}

.ResearchTopicsRankingView_table__Mtf\\+s thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
  border-bottom: 1px solid rgba(15, 52, 96, 0.15);
  color: #0f3460;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  padding: 10px 12px;
  white-space: nowrap;
}

.ResearchTopicsRankingView_table-head--name__u1T09 {
  text-align: left !important;
  width: 280px;
}

.ResearchTopicsRankingView_table-head--rank__HPCLP {
  width: 84px;
  text-align: center !important;
}

.ResearchTopicsRankingView_table__Mtf\\+s tbody td {
  border-bottom: 1px solid rgba(15, 52, 96, 0.08);
  padding: 10px 12px;
  font-size: 13px;
  color: #334155;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.ResearchTopicsRankingView_table__Mtf\\+s tbody tr:hover {
  background: rgba(15, 52, 96, 0.04);
}

.ResearchTopicsRankingView_table-cell--name__18Xro {
  text-align: left !important;
}

.ResearchTopicsRankingView_table-cell--rank__5l8BQ {
  text-align: center !important;
  font-weight: 700;
  color: #fff !important;
  background: #0f3460;
}

.ResearchTopicsRankingView_name-cell__u6Z1B {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.ResearchTopicsRankingView_name-cell__u6Z1B .ResearchTopicsRankingView_avatar__HH3vP {
  flex: 0 0 auto;
}

.ResearchTopicsRankingView_name-cell__u6Z1B span {
  white-space: nowrap;
  font-weight: 600;
  color: var(--text-1, #1a1a1a);
}

/* ─── Empty state ─── */
.ResearchTopicsRankingView_empty__7NcCE {
  padding: 60px 20px;
  text-align: center;
  font-size: 13px;
  color: var(--grey-text, #64748b);
  background: var(--bg-1, #fafafa);
  border-radius: 10px;
  border: 1px dashed rgba(0, 0, 0, 0.1);
}

/* ─── Responsive ─── */
@media only screen and (max-width: 900px) {
  .ResearchTopicsRankingView_body__DU-L- {
    flex-direction: column;
    min-height: 0;
  }
  .ResearchTopicsRankingView_keyword-tabs__-D31U {
    flex: 0 0 auto;
    width: 100%;
    border-right: none;
    border-bottom: 1px solid rgba(15, 52, 96, 0.1);
  }
  .ResearchTopicsRankingView_keyword-tabs-indicator__\\+ILUi {
    width: auto;
    height: 2px;
    bottom: 0;
    left: auto;
  }
  .ResearchTopicsRankingView_keyword-tab__OtGwU {
    border-radius: 8px 8px 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/ResearchTopicsRankingView/ResearchTopicsRankingView.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,yCAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,SAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA,kCAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,6CAAA;AACF;AACE;EACE,oBAAA;AACJ;;AAGA;EACE,yBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;AAAF;;AAGA;EACE,kCAAA;EACA,sCAAA;EACA,2BAAA;EACA,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,yCAAA;AAAF;AAEE;EACE,uBAAA;AAAJ;AAGE;EACE,kCAAA;AADJ;AAIE;EACE,yBAAA;EACA,kCAAA;AAFJ;;AAMA,mCAAA;AACA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;;AAMA,wCAAA;AACA;EACE,gBAAA;EACA,8CAAA;AAHF;AAKE;EACE,QAAA;AAHJ;;AAOA;EACE,yBAAA;EACA,WAAA;AAJF;;AAOA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAJF;AAME;EAEE,yBAAA;AALJ;;AASA;EACE,yBAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AANF;;AASA,qCAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EAEA,wDAAA;EACA,qBAAA;EACA,mDAAA;AAPF;AASE;EACE,UAAA;AAPJ;AAUE;EACE,kCAAA;EACA,kBAAA;AARJ;AAWE;EACE,uBAAA;AATJ;;AAaA;EACE,YAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,YAAA;EACA,kBAAA;AAVF;;AAaA;EACE,WAAA;EACA,iBAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iCAAA;EACA,qBAAA;AAVF;;AAaA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,+CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,2BAAA;EACA,YAAA;AAVF;;AAaA;EACE,WAAA;EACA,6BAAA;AAVF;;AAaA;EACE,+CAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kCAAA;AAVF;;AAaA;EACE,kCAAA;AAVF;;AAaA;EACE,2BAAA;AAVF;;AAaA;EACE,6BAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAVF;AAYE;EACE,cAAA;AAVJ;;AAcA;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;AAXF;;AAcA,wBAAA;AACA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,gCAAA;EACA,mBAAA;EACA,qCAAA;AAXF;;AAcA,uBAAA;AACA;EACE;IACE,sBAAA;IACA,aAAA;EAXF;EAcA;IACE,cAAA;IACA,WAAA;IACA,kBAAA;IACA,8CAAA;EAZF;EAeA;IACE,WAAA;IACA,WAAA;IACA,SAAA;IACA,UAAA;EAbF;EAgBA;IACE,0BAAA;EAdF;AACF","sourcesContent":["/* ─── Research Topics Ranking view ─── */\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 22px 24px 26px;\n  background: var(--bg-2, #fff);\n  border-radius: 16px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n}\n\n.head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.title {\n  margin: 0;\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 12.5px;\n  color: var(--grey-text, #64748b);\n  line-height: 1.5;\n  max-width: 720px;\n}\n\n.body {\n  display: flex;\n  align-items: stretch;\n  gap: 20px;\n  min-height: 480px;\n}\n\n/* ─── Vertical keyword tabs ─── */\n.keyword-tabs {\n  flex: 0 0 200px;\n  min-width: 160px;\n  border-right: 1px solid rgba(15, 52, 96, 0.1);\n\n  :global(.MuiTabs-flexContainer) {\n    align-items: stretch;\n  }\n}\n\n.keyword-tabs-indicator {\n  background-color: #0f3460;\n  width: 3px;\n  left: 0;\n  right: auto;\n}\n\n.keyword-tab {\n  align-items: flex-start !important;\n  justify-content: flex-start !important;\n  text-align: left !important;\n  min-height: 44px;\n  padding: 10px 16px 10px 14px !important;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--grey-text, #64748b);\n  border-radius: 8px 0 0 8px;\n  transition: background 0.15s, color 0.15s;\n\n  :global(.MuiTab-iconWrapper) {\n    align-items: flex-start;\n  }\n\n  &:hover {\n    background: rgba(15, 52, 96, 0.05);\n  }\n\n  &--selected {\n    color: #0f3460 !important;\n    background: rgba(15, 52, 96, 0.07);\n  }\n}\n\n/* ─── Active keyword content ─── */\n.keyword-content {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.keyword-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* ─── Horizontal entity-type tabs ─── */\n.entity-tabs {\n  min-height: 36px;\n  border-bottom: 1px solid rgba(15, 52, 96, 0.1);\n\n  :global(.MuiTabs-flexContainer) {\n    gap: 4px;\n  }\n}\n\n.tabs-indicator {\n  background-color: #0f3460;\n  height: 2px;\n}\n\n.entity-tab {\n  min-height: 36px;\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--grey-text, #64748b);\n\n  &--selected,\n  &:global(.Mui-selected) {\n    color: #0f3460 !important;\n  }\n}\n\n.tab--selected {\n  color: #0f3460 !important;\n}\n\n.panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* ─── Scrollable ranking table ─── */\n.scroll-area {\n  max-height: 520px;\n  overflow-y: auto;\n  overflow-x: auto;\n  padding: 0 8px 4px 0;\n\n  /* Slimmer scrollbar so it doesn't dominate the visual */\n  scrollbar-width: thin;\n  scrollbar-color: rgba(15, 52, 96, 0.25) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(15, 52, 96, 0.25);\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n}\n\n.table-wrap {\n  min-width: 0;\n}\n\n.avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  object-fit: contain;\n}\n\n.avatar--institution {\n  width: 128px;\n  aspect-ratio: 16 / 9;\n}\n\n.avatar--other {\n  width: 60px;\n  aspect-ratio: 1 / 1;\n}\n\n.avatar--fallback {\n  font-size: 11px;\n  font-weight: 700;\n  color: #0f3460;\n  background: rgba(15, 52, 96, 0.1);\n  letter-spacing: 0.3px;\n}\n\n.table {\n  width: 100%;\n  min-width: 360px;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n  border-bottom: 1px solid rgba(15, 52, 96, 0.15);\n  color: #0f3460;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: right;\n  padding: 10px 12px;\n  white-space: nowrap;\n}\n\n.table-head--name {\n  text-align: left !important;\n  width: 280px;\n}\n\n.table-head--rank {\n  width: 84px;\n  text-align: center !important;\n}\n\n.table tbody td {\n  border-bottom: 1px solid rgba(15, 52, 96, 0.08);\n  padding: 10px 12px;\n  font-size: 13px;\n  color: #334155;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.table tbody tr:hover {\n  background: rgba(15, 52, 96, 0.04);\n}\n\n.table-cell--name {\n  text-align: left !important;\n}\n\n.table-cell--rank {\n  text-align: center !important;\n  font-weight: 700;\n  color: #fff !important;\n  background: #0f3460;\n}\n\n.name-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n\n  .avatar {\n    flex: 0 0 auto;\n  }\n}\n\n.name-cell span {\n  white-space: nowrap;\n  font-weight: 600;\n  color: var(--text-1, #1a1a1a);\n}\n\n/* ─── Empty state ─── */\n.empty {\n  padding: 60px 20px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--grey-text, #64748b);\n  background: var(--bg-1, #fafafa);\n  border-radius: 10px;\n  border: 1px dashed rgba(0, 0, 0, 0.1);\n}\n\n/* ─── Responsive ─── */\n@media only screen and (max-width: 900px) {\n  .body {\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .keyword-tabs {\n    flex: 0 0 auto;\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid rgba(15, 52, 96, 0.1);\n  }\n\n  .keyword-tabs-indicator {\n    width: auto;\n    height: 2px;\n    bottom: 0;\n    left: auto;\n  }\n\n  .keyword-tab {\n    border-radius: 8px 8px 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ResearchTopicsRankingView_section__+8t3K`,
	"head": `ResearchTopicsRankingView_head__aSHDa`,
	"title": `ResearchTopicsRankingView_title__UBuia`,
	"subtitle": `ResearchTopicsRankingView_subtitle__qqNu8`,
	"body": `ResearchTopicsRankingView_body__DU-L-`,
	"keyword-tabs": `ResearchTopicsRankingView_keyword-tabs__-D31U`,
	"keyword-tabs-indicator": `ResearchTopicsRankingView_keyword-tabs-indicator__+ILUi`,
	"keyword-tab": `ResearchTopicsRankingView_keyword-tab__OtGwU`,
	"keyword-tab--selected": `ResearchTopicsRankingView_keyword-tab--selected__v5sF+`,
	"keyword-content": `ResearchTopicsRankingView_keyword-content__97tmU`,
	"keyword-panel": `ResearchTopicsRankingView_keyword-panel__k+fx2`,
	"entity-tabs": `ResearchTopicsRankingView_entity-tabs__B0vot`,
	"tabs-indicator": `ResearchTopicsRankingView_tabs-indicator__9idT+`,
	"entity-tab": `ResearchTopicsRankingView_entity-tab__56Fqr`,
	"entity-tab--selected": `ResearchTopicsRankingView_entity-tab--selected__VWWZD`,
	"tab--selected": `ResearchTopicsRankingView_tab--selected__9NSwh`,
	"panel": `ResearchTopicsRankingView_panel__iOM55`,
	"scroll-area": `ResearchTopicsRankingView_scroll-area__9F1WE`,
	"table-wrap": `ResearchTopicsRankingView_table-wrap__KzHdG`,
	"avatar": `ResearchTopicsRankingView_avatar__HH3vP`,
	"avatar--institution": `ResearchTopicsRankingView_avatar--institution__h48D5`,
	"avatar--other": `ResearchTopicsRankingView_avatar--other__zC01p`,
	"avatar--fallback": `ResearchTopicsRankingView_avatar--fallback__j+YfJ`,
	"table": `ResearchTopicsRankingView_table__Mtf+s`,
	"table-head--name": `ResearchTopicsRankingView_table-head--name__u1T09`,
	"table-head--rank": `ResearchTopicsRankingView_table-head--rank__HPCLP`,
	"table-cell--name": `ResearchTopicsRankingView_table-cell--name__18Xro`,
	"table-cell--rank": `ResearchTopicsRankingView_table-cell--rank__5l8BQ`,
	"name-cell": `ResearchTopicsRankingView_name-cell__u6Z1B`,
	"empty": `ResearchTopicsRankingView_empty__7NcCE`
};
export default ___CSS_LOADER_EXPORT___;
